import { LessonUnitServerType, LessonUnitType } from './types';

export const normalizeLessonUnit = (
  firstUnit: LessonUnitServerType
): LessonUnitType => ({
  lessonId: firstUnit.lesson_id,
  id: firstUnit.id,
});
